import { CredentialingPermissionsEffects } from './credentialing-permissions.effect';
import { CredentialingSettingsEffects } from './credentialing-settings.effects';

export const credentialingSettingsEffects = [CredentialingSettingsEffects, CredentialingPermissionsEffects];
